import PropTypes from 'prop-types'
import React from 'react'
import gql from 'graphql-tag'
import { DateTime } from 'luxon'
import Box from '@material-ui/core/Box'
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography'
import LinearProgress from '@material-ui/core/LinearProgress'
import { useQuery } from '@apollo/client'

import ScrollWrapper from '@components/scroll-wrapper'
import GroupEventCard from '@components/group-event-card'
import { useStyles } from './styles'

const GET_FACILITY_EVENTS = gql`
  query GetFacilityGroupEvents($slug: String, $startDateTime: DateTimeRangeInput!, $includeCanceled: Boolean, $includeRegistrationClosed: Boolean) {
    groupEvents(slug: $slug) {
      id
      coachFacility {
        id
        name
        zipCode
        city
        state
        timezone
        groupEvents(startDateTime: $startDateTime, limit: 4, orderBy: [{ field: START_DATE_TIME, direction: ASC }], includeCanceled: $includeCanceled, includeRegistrationClosed: $includeRegistrationClosed) {
          title
          startDateTime
          endDateTime
          timezone
          featuredImageUrl
          slug
          unlisted
        }
      }
    }
  }
`

const MoreEvents = ({ groupEventSlug }) => {
  const classes = useStyles()
  const today = DateTime.local().startOf('day').toISO()

  const { data, loading, error } = useQuery(GET_FACILITY_EVENTS, {
    variables: {
      slug: groupEventSlug,
      startDateTime: { from: today },
      includeCanceled: false,
      includeRegistrationClosed: false,
    },
    context: { clientName: 'coach-tools' },
  })

  if (loading) {
    return (
      <Box my={8}>
        <LinearProgress color="secondary" />
      </Box>
    )
  }
  if (error) return null

  const coachFacility = data.groupEvents[0]?.coachFacility

  const filteredFacilityEvents = (coachFacility?.groupEvents || [])
    .filter(item => item.slug !== groupEventSlug && !item.unlisted)

  const formattedFacilityEvents = filteredFacilityEvents.map((item) => {
    return {
      slug: item.slug,
      title: item.title,
      start_date_time: item.startDateTime,
      end_date_time: item.endDateTime,
      featured_image_url: item.featuredImageUrl,
      coach_facility_name: coachFacility.name,
      coach_facility_zip: coachFacility.zipCode,
      coach_facility_state: coachFacility.state,
      coach_facility_city: coachFacility.city,
      coach_facility_timezone: coachFacility.timezone,
    }
  })

  if (formattedFacilityEvents.length === 0) return null

  return (
    <>
      <Divider className={classes.divider} />
      <Typography variant="h6" style={{ margin: '30px 0' }}>
        More events at {coachFacility.name}
      </Typography>
      <ScrollWrapper
        minCardWidth={240}
        scrollItems={formattedFacilityEvents}
        keyField="slug"
      >
        {args => <GroupEventCard {...args} source="event-search-directory" />}
      </ScrollWrapper>
    </>
  )
}

MoreEvents.propTypes = {
  groupEventSlug: PropTypes.string.isRequired,
}

export default MoreEvents
